(function () {
  'use strict';

  const MONEY_FMT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

  // ---------- Shared: AJAX add to cart, then refresh the cart drawer in place ----------
  // Uses the theme's <cart-drawer> custom element (Dawn-style renderContents) so the
  // page never does a full reload. Falls back to /cart only if the drawer is absent.
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function drawerSectionIds() {
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  async function addToCartAndRefresh(items) {
    const drawer = getCartDrawer();
    const body = { items: items };
    if (drawer) {
      body.sections = drawerSectionIds();
      body.sections_url = window.location.pathname;
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    const parsed = await res.json();
    if (!res.ok) {
      throw new Error(parsed && parsed.description ? parsed.description : 'Add to cart failed');
    }
    if (drawer && parsed.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(parsed);
      if (typeof drawer.open === 'function') drawer.open();
    } else {
      // No drawer on this template (e.g. cart page) — soft refresh of cart only.
      window.location.href = '/cart';
    }
    return parsed;
  }

  // ---------- TIER 1: configurator above ATC ----------
  const tier1 = document.querySelector('.acc-tier1');
  if (tier1) {
    const productPrice = parseFloat(tier1.dataset.productPrice || '0');
    const cards = tier1.querySelectorAll('.acc-card');
    const atcBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], button[name="add"]');

    // Resolve Dawn's actual product form fresh each time (it lives inside
    // <product-form>). Looking it up at load can miss it or grab the wrong node.
    function getProductForm() {
      const pf = document.querySelector('product-form form')
              || document.querySelector('form[action*="/cart/add"]');
      return pf;
    }

    // Keep Dawn's form in sync with selected accessories via hidden items[] inputs.
    // Dawn submits new FormData(form); Shopify /cart/add accepts items[N][id].
    function syncHiddenInputs() {
      const form = getProductForm();
      if (!form) return;
      // Remove any previously-injected accessory inputs.
      form.querySelectorAll('input[data-acc-item="1"]').forEach(function (n) { n.remove(); });
      let idx = 0;
      cards.forEach(function (c) {
        if (!c.classList.contains('is-selected')) return;
        const vid = parseInt(c.dataset.variantId);
        if (!vid) return;
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'items[' + idx + '][id]';
        idInput.value = vid;
        idInput.setAttribute('data-acc-item', '1');
        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'items[' + idx + '][quantity]';
        qtyInput.value = '1';
        qtyInput.setAttribute('data-acc-item', '1');
        form.appendChild(idInput);
        form.appendChild(qtyInput);
        idx++;
      });
    }

    function recalcTotal() {
      let extra = 0;
      cards.forEach(c => {
        if (c.classList.contains('is-selected')) extra += parseFloat(c.dataset.price);
      });
      if (atcBtn) {
        const total = productPrice + extra;
        const orig = atcBtn.dataset.origLabel || atcBtn.textContent.trim();
        if (!atcBtn.dataset.origLabel) atcBtn.dataset.origLabel = orig;
        const span = atcBtn.querySelector('span') || atcBtn;
        span.textContent = extra > 0
          ? `${orig.replace(/\s*—.*$/, '').trim()} — ${MONEY_FMT.format(total)}`
          : orig;
      }
    }

    cards.forEach(card => {
      if (card.dataset.unavailable) return;
      card.addEventListener('click', e => {
        if (e.target.tagName === 'A') return;
        card.classList.toggle('is-selected');
        recalcTotal();
        syncHiddenInputs();
      });
    });
  }

  // ---------- TIER 2: frequently-added list ----------
  const tier2 = document.querySelector('.acc-tier2');
  if (tier2) {
    const cards = tier2.querySelectorAll('.acc-card');
    const subtotalEl = tier2.querySelector('[data-tier2-subtotal]');
    const addBtn = tier2.querySelector('[data-tier2-add]');

    function refresh() {
      const selected = Array.from(cards).filter(c => c.classList.contains('is-selected'));
      const total = selected.reduce((acc, c) => acc + parseFloat(c.dataset.price), 0);
      subtotalEl.textContent = `${selected.length} selected — ${MONEY_FMT.format(total)}`;
      addBtn.disabled = selected.length === 0;
    }

    cards.forEach(card => {
      if (card.dataset.unavailable) return;
      card.addEventListener('click', e => {
        if (e.target.tagName === 'A') return;
        card.classList.toggle('is-selected');
        refresh();
      });
    });

    addBtn.addEventListener('click', async () => {
      const selected = Array.from(cards).filter(c => c.classList.contains('is-selected'));
      if (selected.length === 0) return;
      const items = selected.map(c => ({ id: parseInt(c.dataset.variantId), quantity: 1 }));
      const origLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      try {
        await addToCartAndRefresh(items);
      } catch (err) {
        console.error('Tier 2 add failed', err);
        alert('Could not add items. Please try again.');
      } finally {
        addBtn.textContent = origLabel;
        addBtn.disabled = false;
      }
    });
  }

  // ---------- TIER 3: cart drawer quick-add (delegated; drawer re-renders) ----------
  document.addEventListener('click', async function (e) {
    if (!e.target.matches('.acc-card__quick-add')) return;
    const btn = e.target;
    if (btn.disabled) return;
    const origLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await addToCartAndRefresh([{ id: parseInt(btn.dataset.variantId), quantity: 1 }]);
      // Drawer re-renders from server HTML, so this button node is replaced; no reset needed.
    } catch (err) {
      console.error('Quick add failed', err);
      btn.textContent = origLabel;
      btn.disabled = false;
    }
  });
})();
